import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  temperature: null,
  feelsLike: null,
  emoji: '',
  astronomy: {
    sunrise: null,
    sunset: null,
  },
};

const WEATHER_SYMBOL = {
  Unknown: '✨',
  Cloudy: '☁️',
  Fog: '🌫',
  HeavyRain: '🌧',
  HeavyShowers: '🌧',
  HeavySnow: '❄️',
  HeavySnowShowers: '❄️',
  LightRain: '🌦',
  LightShowers: '🌦',
  LightSleet: '🌧',
  LightSleetShowers: '🌧',
  LightSnow: '🌨',
  LightSnowShowers: '🌨',
  PartlyCloudy: '⛅️',
  Sunny: '☀️',
  ThunderyHeavyRain: '🌩',
  ThunderyShowers: '⛈',
  ThunderySnowShowers: '⛈',
  VeryCloudy: '☁️',
};

const weatherSlice = createSlice({
  name: 'weather',
  initialState,
  reducers: {
    weatherUpdated(state, action) {
      const { temperature, feelsLike, emoji, astronomy } = action.payload;
      state.temperature = temperature;
      state.feelsLike = feelsLike;
      state.emoji = emoji;
      state.astronomy = astronomy;
    },
    weatherUpdateError(state) {
      // Keep previous data on error; no state change
    },
  },
});

export const { weatherUpdated, weatherUpdateError } = weatherSlice.actions;

export const updateWeather = () => dispatch => {
  const url = 'https://wttr.in/~51.9994572,4.362724538544?format=j1';

  const requestWeather = () => {
    axios
      .get(url)
      .then(({ data }) => {
        const temperature = Number(data.current_condition[0].temp_C);
        const feelsLike = Number(data.current_condition[0].FeelsLikeC);
        const description = data.current_condition[0].weatherDesc[0].value;
        const emoji = WEATHER_SYMBOL[description] || '';
        const astronomy = {
          sunrise: data.weather[0].astronomy[0].sunrise,
          sunset: data.weather[0].astronomy[0].sunset,
        };

        dispatch(weatherUpdated({ temperature, feelsLike, emoji, astronomy }));
      })
      .catch(() => {
        dispatch(weatherUpdateError());
      });
  };

  const interval = setInterval(requestWeather, 900000);
  // eslint-disable-next-line no-unused-vars
  void interval; // preserve behavior; interval ID unused in state
  requestWeather();
};

export default weatherSlice.reducer;


